/** Terms and sheet numbers, for the new-sheet form and the Sheets page. Pure. */

/** the fields of a sheet summary this needs */
interface Numbered {
  termYear?: string | null;
  kind: string;
  label: string;
}

/**
 * The winter term a date belongs to: October 2026 to March 2027 is term 2026, and from
 * April on the coming one, which the summer prepares (as shared/term.ts `termYearOf`).
 */
export function currentTerm(now = new Date()): string {
  return String(now.getMonth() >= 3 ? now.getFullYear() : now.getFullYear() - 1);
}

const NUMBER_SEQUENCE = ['0', ...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'];

/** The next sheet number nobody has used in this term and series. */
export function nextSheetNumber(sheets: Numbered[], term: string, kind: string): string {
  const used = sheets
    .filter((s) => (s.termYear ?? '') === term && s.kind === kind)
    .map((s) => NUMBER_SEQUENCE.indexOf(s.label.toUpperCase()))
    .filter((i) => i >= 0);
  if (!used.length) return 'A';
  return NUMBER_SEQUENCE[Math.min(Math.max(...used) + 1, NUMBER_SEQUENCE.length - 1)]!;
}

